import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme, useTrivia } from "../../../../hooks";
import { useParams } from "react-router-dom";
import { mashupRewardItems } from "../data";

const regionsData = [
  {
    label: "Greater Accra Region",
    cities: [
      { label: "Accra Central", value: 0 },
      { label: "Accra Mall", value: 1 },
      { label: "Achimota", value: 2 },
      { label: "Akweteyman", value: 3 },
      { label: "Ashaiman", value: 4 },
      { label: "Circle", value: 5 },
      { label: "Dansoman", value: 6 },
      { label: "Darkuman", value: 7 },
      { label: "East Legon", value: 8 },
      { label: "Graphic Road", value: 9 },
      { label: "Haatso", value: 10 },
      { label: "Junction Mall", value: 11 },
      { label: "Madina", value: 12 },
      { label: "McCarthy", value: 13 },
      { label: "NIA", value: 14 },
      { label: "Osu", value: 15 },
      { label: "Roman Ridge", value: 16 },
      { label: "Social Welfare", value: 17 },
      { label: "Spintex", value: 18 },
      { label: "Tema 1", value: 19 },
      { label: "Tema 25", value: 20 },
      { label: "Tema 6", value: 21 },
      { label: "Tesano", value: 22 },
      { label: "Teshie", value: 23 },
      { label: "Tudu", value: 24 },
      { label: "Westhills", value: 25 },
    ],
  },
  {
    label: "Ashanti Region",
    cities: [
      { label: "Abuakwa", value: 0 },
      { label: "Adum", value: 1 },
      { label: "Atonsu", value: 2 },
      { label: "Ayigya", value: 3 },
      { label: "Bantama", value: 4 },
      { label: "Kejetia", value: 5 },
      { label: "KNUST", value: 6 },
      { label: "Kumasi City Mall", value: 7 },
      { label: "Konongo", value: 8 },
      { label: "Mampong", value: 9 },
      { label: "Nhyiaeso", value: 10 },
      { label: "Obuasi", value: 11 },
      { label: "Suame", value: 12 },
      { label: "Tafo", value: 13 },
    ],
  },
  {
    label: "Western Region",
    cities: [
      { label: "Takoradi Main", value: 0 },
      { label: "Takoradi MC", value: 1 },
      { label: "Tarkwa", value: 2 },
      { label: "Bibiani", value: 3 },
    ],
  },
  {
    label: "Central Region",
    cities: [
      { label: "Cape Coast Abura", value: 0 },
      { label: "Cape Coast", value: 1 },
      { label: "Kasoa", value: 2 },
      { label: "Winneba", value: 3 },
    ],
  },
  {
    label: "Eastern Region",
    cities: [
      { label: "Donkorkrom", value: 0 },
      { label: "Koforidua", value: 1 },
      { label: "New Abirem", value: 2 },
      { label: "Akropong", value: 11 },
    ],
  },
  {
    label: "Brong Ahafo Region",
    cities: [
      { label: "Goaso", value: 0 },
      { label: "Sunyani", value: 1 },
    ],
  },
  {
    label: "Volta Region",
    cities: [
      { label: "Atimpoku", value: 0 },
      { label: "Ho", value: 1 },
    ],
  },
  { label: "Northern Region", cities: [{ label: "Tamale", value: 0 }] },
  { label: "Upper East Region", cities: [{ label: "Bolgatanga", value: 0 }] },
  {
    label: "Upper West Region",
    cities: [
      { label: "Wa", value: 0 },
      { label: "Lawra", value: 1 },
    ],
  },
];

const checkValidQuantity = (qty) => {
  if (!qty || isNaN(qty) || parseFloat(qty) - parseInt(qty) !== 0 || qty < 1)
    return false;
  return true;
};

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;

const voucherData = {
  melcom: {
    name: "Melcom Voucher",
    value: 100,
    imageUrl: `${SERVER_URL}/assets/images/melcomemw.jpg`,
  },
  potbelly: {
    name: "Potbelly Voucher",
    value: 100,
    imageUrl: `${SERVER_URL}/assets/images/potbellymw.jpg`,
  },
  kfc: {
    name: "KFC Voucher",
    value: 100,
    imageUrl: `${SERVER_URL}/assets/images/kfcmw.jpg`,
  },
  airtime: {
    name: "Airtime",
    value: 10,
    imageUrl: `${SERVER_URL}/assets/images/airtime.jpg`,
  },
  shoprite: {
    name: "Shoprite Voucher",
    value: 100,
    imageUrl: `${SERVER_URL}/assets/images/shopritemw.jpg`,
  },
  silverbird: {
    name: "Silverbird Ticket",
    value: null,
    imageUrl: `${SERVER_URL}/assets/images/ticketmw.jpg`,
  },
  // Other non-pulse items
  waterBottle: {
    name: "Water Bottle",
    value: null,
    imageUrl: `${SERVER_URL}/assets/images/souvenirs/waterbottle.jpg`,
  },
  powerbank: {
    name: "Pulse Wireless Powerbank",
    value: null,
    imageUrl: `${SERVER_URL}/assets/images/souvenirs/powerbank.jpg`,
  },
  hoodedTShirt: {
    name: "Pulse Hooded T-shirt",
    value: null,
    imageUrl: `${SERVER_URL}/assets/images/souvenirs/hooded-shirt.jpg`,
  },
  slingBag: {
    name: "MTN Sling Bag",
    value: null,
    imageUrl: `${SERVER_URL}/assets/images/souvenirs/slingbag.jpg`,
  },
  bluetoothSpeaker: {
    name: "Bluetooth Speaker",
    value: null,
    imageUrl: `${SERVER_URL}/assets/images/souvenirs/bluetooth-speaker.jpg`,
  },
  backpack: {
    name: "Back Pack",
    value: null,
    imageUrl: `${SERVER_URL}/assets/images/souvenirs/backpack.jpg`,
  },
  stationerySet: {
    name: "Stationery Set",
    value: null,
    imageUrl: `${SERVER_URL}/assets/images/souvenirs/stationery-set.jpg`,
  },
  exerciseBooks: {
    name: "Exercise Books",
    value: null,
    imageUrl: `${SERVER_URL}/assets/images/souvenirs/exercise-book.jpg`,
  },
};

const useTriviaPickup = () => {
  const { themeContext, theme } = useTheme();
  const { redeemReward } = useTrivia();
  const { itemId } = useParams();
  const regionFmt = regionsData.map(({ label: region }) => ({
    label: region,
    value: region,
  }));

  const { image, name, amount } =
    mashupRewardItems.find((item) => item.id === itemId) || {};
  const [showAlert, setShowAlert] = useState(false);
  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const [quantity, setQuantity] = useState(1);
  const [region, setRegion] = useState();
  const [officeLocation, setOfficeLocation] = useState();
  const [officeLocations, setOfficeLocations] = useState([]);
  const [isValidQuantity, setIsValidQuantity] = useState(false);
  const [updatedUserPoints, setUpdatedUserPoints] = useState(0);

  useEffect(() => {
    setOfficeLocation(null);
    if (region) {
      const foundOfficeLocations = regionsData.find(
        ({ label }) => label === region
      );
      if (foundOfficeLocations) {
        setOfficeLocations(
          foundOfficeLocations.cities.map(({ label }) => ({
            label,
            value: label,
          }))
        );
      }
    } else {
      setOfficeLocations([]);
    }
  }, [region]);

  const handleSubmit = ({ rewardType, value, region, officeLocation }) => {
    redeemReward({ rewardType, value, region, officeLocation });
    setShowAlert(true);
  };

  return {
    background,
    history,
    regionFmt,
    image,
    name,
    amount,
    showAlert,
    setShowAlert,
    quantity,
    setQuantity,
    region,
    setRegion,
    officeLocation,
    setOfficeLocation,
    officeLocations,
    setOfficeLocations,
    isValidQuantity,
    setIsValidQuantity,
    handleSubmit,
    updatedUserPoints,
    unitPoints: 50,
    voucherData,
  };
};

export default useTriviaPickup;
